import React from 'react';
import { Tabs as MaterialTabs, Tab, Box, useMediaQuery, useTheme } from '@mui/material';
import { TabsProps } from './types';

const Tabs = ({ tabs, activeTab, onTabChange, ariaLabel }: TabsProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        const newActiveTab = tabs.find((tab) => tab.id === newValue);
        if (newActiveTab) {
            onTabChange(newActiveTab);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
        let newIndex: number | null = null;
        const currentIndex = tabs.findIndex((tab) => tab.id === activeTab.id);

        switch (event.key) {
            case 'ArrowRight':
                newIndex = (currentIndex + 1) % tabs.length;
                break;
            case 'ArrowLeft':
                newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                break;
            default:
                break;
        }

        if (newIndex !== null && newIndex !== currentIndex) {
            const newActiveTab = tabs[newIndex];
            onTabChange(newActiveTab);
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <MaterialTabs
                value={activeTab.id}
                onChange={handleChange}
                aria-label={ariaLabel}
                onKeyDown={handleKeyDown}
                sx={{
                    '& .MuiTabs-indicator': {
                        display: 'none',
                    },
                    '& .MuiTab-root': {
                        fontSize: isMobile ? '12px' : '14px',
                        textTransform: 'none',
                        height: isMobile ? '34px' : '42px',
                        display: 'flex',
                        alignItems: 'center',
                        minWidth: 0,
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&:focus': {
                            outline: 'none',
                            backgroundColor: 'transparent',
                        },
                        '& .MuiTab-wrapper': {
                            transition: 'none',
                        },
                    },
                    '& .MuiTabs-flexContainer': {
                        transition: 'none',
                    },
                    '& .MuiTab-root.Mui-selected': {
                        color: 'common.black',
                        borderBottom: '2px solid',
                        borderColor: 'common.black',
                        fontWeight: '500',
                        padding: 0,
                    },
                    '& .MuiTab-root:not(.Mui-selected)': {
                        color: 'common.grey1',
                        padding: 0,
                        borderBottom: '2px solid transparent'
                    },
                    '& .MuiTab-root span': {
                        border: '0px solid transparent',
                        display: 'inline-block',
                    },
                }}
            >
                {tabs.map((tab, index) => (
                    <Tab
                        key={tab.id}
                        label={<span>{tab.label}</span>}
                        value={tab.id}
                        id={`tab-${tab.id}`}
                        aria-controls={`tabpanel-${tab.id}`}
                        sx={{
                            marginRight: index < tabs.length - 1 ? '24px' : 0,
                            '&:focus': {
                                outline: 'none',
                                backgroundColor: 'transparent',
                            },
                        }}
                    />
                ))}
            </MaterialTabs>
        </Box>
    );
};

export default Tabs;
